import React from 'react';
import SectionLabel from './SectionLabel';
import useFadeIn from '../hooks/useFadeIn';
import '../styles/theme.css';
import { certifications } from '../data';

export default function Certifications() {
  const fade = useFadeIn();

  return (
    <section id="certifications" className="section">
      <SectionLabel>Certifications</SectionLabel>
      <div ref={fade.ref} style={fade.style} className="grid-2">
          {certifications.map((cert) => (
            <div className="about__badge" key={cert.id}>
              <img src={cert.icon.src} alt={cert.icon.alt} title={cert.icon.title} width={cert.icon.size} height={cert.icon.size}/>
              <strong>{cert.title}</strong> — {cert.date}
            </div>
          ))}
      </div>
    </section> 
  );
}
